import TextEditorField from './TextEditorField.component';

export default TextEditorField;